import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopHeader from './ACE/components/TopHeader';
import Navbar from './ACE/components/Navbar';
import EnquiryButton from './ACE/components/EnquiryButton';
import Home from './ACE/pages/Home';
import About from './ACE/pages/About';
// import Academics from './ACE/pages/Academics';
import ContactUs from './ACE/homepage/ContactUs';
import Slider from './ACE/sliders/Slider'
import SliderACE from './ACE/sliders/SliderACE'
import Card00 from './ACE/cards/Card00'
import Card01 from './ACE/cards/Card01'
import MissionStatement from './ACE/mainpagelinks/aboutus/MissionStatement';
import ManagementMessage from './ACE/mainpagelinks/aboutus/ManagementMessage';
import GeneralInformation from './ACE/mainpagelinks/aboutus/GeneralInformation';
import Academics from './ACE/mainpagelinks/academics/academics';
import Primary from './ACE/mainpagelinks/academics/primary'
import Secondary from './ACE/mainpagelinks/academics/Secondary';
import Stage3 from './ACE/mainpagelinks/academics/Stage3';
import Stage4 from './ACE/mainpagelinks/academics/Stage4';
import Stage5 from './ACE/mainpagelinks/academics/Stage5';
import SchoolFee from './ACE/mainpagelinks/admissions/SchoolFee';
import Clubs from './ACE/mainpagelinks/Special Facilities/Clubs';
import Counsellor from './ACE/mainpagelinks/Special Facilities/Counsellor';
import Libraries from './ACE/mainpagelinks/Special Facilities/Libraries';
import Security from './ACE/mainpagelinks/Special Facilities/Security';
import Swimming from './ACE/mainpagelinks/Special Facilities/Swimming';
import Transport from './ACE/mainpagelinks/Special Facilities/Transport';
import Footer from './ACE/components/Footer';
import SpecialFacilities from './ACE/mainpagelinks/Special Facilities/SpecialFacilities';
import WhyUs from './ACE/homepage/whyus';
import FAQ from './ACE/homepage/FAQ';
import Gallery01 from './ACE/gallery/gallery01';
import Gallery02 from './ACE/gallery/gallery02';
import Gallery03 from './ACE/gallery/gallery03';
import Event01 from './ACE/events/Event01';
import Event02 from './ACE/events/Event02';
import Event03 from './ACE/events/Event03';
import Event04 from './ACE/events/Event04';
import Event05 from './ACE/events/Event05';
import Location from './ACE/homepage/Location'
import Slider02 from './ACE/sliders/Slider02'


const AppACE = () => (
  <Router>
    <TopHeader />
    <Navbar />
    <Routes>
      <Route path="/" element={<Slider />} />
      <Route path="/Home" element={<Home />} />
      <Route path="/MissionStatement" element={<MissionStatement />} />
      <Route path="/ManagementMessage" element={<ManagementMessage />} />
      <Route path="/GeneralInformation" element={<GeneralInformation />} />
      <Route path="/Academics" element={<Academics />} />
      <Route path="/Primary" element={<Primary />} />
      <Route path="/Secondary" element={<Secondary />} />
      <Route path="/Stage3" element={<Stage3 />} />
      <Route path="/Stage4" element={<Stage4 />} />
      <Route path="/Stage5" element={<Stage5 />} />
      <Route path="/SchoolFee" element={<SchoolFee />} />
      <Route path="/Clubs" element={<Clubs />} />
      <Route path="/Counsellor" element={<Counsellor />} />
      <Route path="/Libraries" element={<Libraries />} />
      <Route path="/Security" element={<Security />} />
      <Route path="/Swimming" element={<Swimming />} />
      <Route path="/Transport" element={<Transport />} />
      <Route path="/FAQ" element={<FAQ />} />
      <Route path="/about" element={<About />} />
      <Route path="/academics" element={<Academics />} />
      <Route path="/ContactUs" element={<ContactUs />} />
      <Route path="/Card00" element={<Card00 />} />
      <Route path="/Card01" element={<Card00 />} />
      <Route path="/SpecialFacilities" element={<SpecialFacilities />} />    
      <Route path="/SpecialFacilities" element={<SpecialFacilities />} />
      <Route path="/WhyUs" element={<WhyUs />} />  
      <Route path="/Gallery01" element={<Gallery01 />} />  
      <Route path="/Gallery02" element={<Gallery02 />} />  
      <Route path="/Gallery03" element={<Gallery03 />} />  
      <Route path="/Event01" element={<Event01 />} />  
      <Route path="/Event02" element={<Event02 />} />  
      <Route path="/Event03" element={<Event03 />} />  
      <Route path="/Event04" element={<Event04 />} />  
      <Route path="/Event05" element={<Event05 />} />  
      <Route path="/Location" element={<Location />} />  

     <Route path="/Slider02" element={<Slider />} />  
      {/* Add other routes here */}
    </Routes>
    {/* <Card01 /> */}
    <Footer />
    <EnquiryButton />
  </Router>
);

export default AppACE;






// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Topbar from './components/Topbar';
// import Sidebar from './components/Sidebar';
// import Home from './pages/Home';
// import About from './pages/About';
// import Contact from './pages/Contact';
// import APIReact01 from './API/APIReact01'
// import APIReact02 from './API/APIReact02'
// import APIReact03 from './API/APIReact03'

// import './App.css'; // 👈 Add this for custom styles

// function App() {
//   return (
//     <Router>
//       <div className="app-container">
//         <Topbar />
//         <div className="main-container">
//           <Sidebar />
//           <div className="content-container">
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/about" element={<About />} />
//               <Route path="/contact" element={<Contact />} />
//               <Route path="/APIReact01" element={<APIReact01 />} />
//               <Route path="/APIReact02" element={<APIReact02 />} />
//               <Route path="/APIReact03" element={<APIReact03 />} />
//             </Routes>
//           </div>
//         </div>
//       </div>
//     </Router>
//   );
// }
// export default App;














// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Topbar from './components/Topbar';
// import Sidebar from './components/Sidebar';
// import Home from './pages/Home';
// import About from './pages/About';
// import Contact from './pages/Contact';
// import APIReact01 from './API/APIReact01'
// import APIReact02 from './API/APIReact02'
// import './App.css'; // 👈 Add this for custom styles

// function App() {
//   return (
//     <Router>
//       <div className="app-container">
//         <Topbar />
//         <div className="main-container">
//           <Sidebar />
//           <div style={{ padding: '20px', flex: 1 }}>
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/about" element={<About />} />
//               <Route path="/contact" element={<Contact />} />
//               <Route path="/APIReact01" element={<APIReact01 />} />
//               <Route path="/APIReact02" element={<APIReact02 />} />
//             </Routes>
//           </div>
//         </div>
//       </div>
//     </Router>
//   );
// }

// export default App;
